import { render } from "./SonMerchant.vue?vue&type=template&id=660d87c5&scoped=true"
import script from "./SonMerchant.vue?vue&type=script&lang=js"
export * from "./SonMerchant.vue?vue&type=script&lang=js"

import "./SonMerchant.vue?vue&type=style&index=0&id=660d87c5&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660d87c5"]])

export default __exports__